// import React, { useEffect, useState, forwardRef } from "react";
// import Col from "react-bootstrap/Col";
// import Row from "react-bootstrap/Row";
// import { formatTimeDifference } from "../../../../common/Validations";
// import "./ShowHorizontalStatus.css";

// const ShowHorizontalStatus = forwardRef((props, ref) => {
//   const [loadData, setLoadData] = useState(props?.rowdatamodal);
//   const [animateSteps, setAnimateSteps] = useState([]);
//   const isDetailedView = props?.isDetailedView || false;

//   useEffect(() => {
//     setLoadData(props?.rowdatamodal);

//     if (props?.rowdatamodal?.length > 0) {
//       props.rowdatamodal.forEach((_, index) => {
//         setTimeout(() => {
//           setAnimateSteps((prev) => [...prev, index]);
//         }, index * 300);
//       });
//     }
//   }, [props?.rowdatamodal]);

//   const getStatusConfig = (action) => {
//     const configs = {
//       Created: {
//         badge: "CB",
//         color: "#dc3545",
//         status: "Created",
//         labelBg: "#fff1f0",
//         icon: "bi-pencil-square",
//         fillColor: "#28a745",
//       },
//       Pending: {
//         badge: "PD",
//         color: "#dc3545",
//         status: "Pending",
//         labelBg: "#ffebee",
//         icon: "bi-hourglass-split",
//         fillColor: "#dc3545",
//       },
//       Approve: {
//         badge: "AP",
//         color: "#28a745",
//         status: "Approved",
//         labelBg: "#e8f5e9",
//         icon: "bi-check-circle-fill",
//         fillColor: "#28a745",
//       },
//       // Add this scenario
//       Approved: {
//         badge: "AP",
//         color: "#28a745",
//         status: "Approved",
//         labelBg: "#e8f5e9",
//         icon: "bi-check-circle-fill",
//         fillColor: "#28a745",
//       },

//       Submit: {
//         badge: "SB",
//         color: "#17a2b8",
//         status: "Submit",
//         labelBg: "#e0f7fa",
//         icon: "bi-send-fill",
//         fillColor: "#17a2b8",
//       },
//       Reject: {
//         badge: "RJ",
//         color: "#dc3545",
//         status: "Rejected",
//         labelBg: "#ffebee",
//         icon: "bi-x-circle-fill",
//         fillColor: "#dc3545",
//       },
//       Completed: {
//         badge: "SY",
//         color: "#0d6efd",
//         status: "Completed",
//         labelBg: "#e3f2fd",
//         icon: "bi-check-all",
//         fillColor: "#0d6efd",
//       },
//     };

//     return (
//       configs[action] || {
//         badge: "NA",
//         color: "#6c757d",
//         status: "-",
//         labelBg: "#f5f5f5",
//         icon: "bi-question-circle",
//         fillColor: "#6c757d",
//       }
//     );
//   };

//   const isPendingOrRejected = (action) => {
//     return action === "Pending" || action === "Reject";
//   };

//   const getProgressPercent = () => {
//     if (!loadData || loadData.length === 0) return 0;

//     const totalSteps = loadData.length;

//     const stopIndex = loadData.findIndex(
//       (item) =>
//         item.currentAction === "Pending" || item.currentAction === "Reject",
//     );

//     if (stopIndex === -1) {
//       return 100;
//     } else if (stopIndex === 0) {
//       return 0;
//     } else {
//       const completedSteps = stopIndex - 1;
//       const totalSegments = totalSteps - 1;
//       const basePercent = (completedSteps / totalSegments) * 100;
//       const segmentWidth = 100 / totalSegments;
//       const extensionPercent = segmentWidth * 0.25;
//       return basePercent + extensionPercent;
//     }
//   };

//   return (
//     <div className="workflow-status-wrapper" ref={ref}>
//       {loadData && (
//         <Row className="workflow-status-row">
//           <Col xs={12} className="workflow-status-col">
//             <div className="card border-0 shadow-sm workflow-status-card">
//               <div className="card-body workflow-status-body">
//                 {isDetailedView ? (
//                   <div className="timeline-horizontal">
//                     <div className="connecting-line">
//                       <div
//                         className="connecting-line-fill"
//                         style={{
//                           width: `${getProgressPercent()}%`,
//                         }}
//                       ></div>
//                     </div>

//                     {loadData?.length > 0 &&
//                       loadData.map((item, index) => {
//                         const config = getStatusConfig(item.currentAction);
//                         const isFirst = index === 0;
//                         const isLast = index === loadData.length - 1;
//                         const isCompleted = item.currentAction === "Completed";
//                         const isAnimated = animateSteps.includes(index);
//                         const isPending = isPendingOrRejected(
//                           item.currentAction,
//                         );

//                         return (
//                           <div key={index} className="timeline-step">
//                             <div className="step-circle-wrapper">
//                               <div
//                                 className={`step-circle ${
//                                   isFirst
//                                     ? "start-circle"
//                                     : isLast
//                                       ? "end-circle"
//                                       : "middle-circle"
//                                 } ${isAnimated ? "animate-fill" : ""}`}
//                               >
//                                 {!isFirst && !isLast && isAnimated && (
//                                   <div
//                                     className="circle-fill"
//                                     style={{
//                                       backgroundColor: config.fillColor,
//                                     }}
//                                   ></div>
//                                 )}

//                                 <div className="circle-content">
//                                   {isFirst ? (
//                                     <span className="circle-text">START</span>
//                                   ) : isLast && isCompleted ? (
//                                     <i className="bi bi-check-all circle-icon-small"></i>
//                                   ) : (
//                                     <i
//                                       className={`${config.icon} circle-icon-small`}
//                                     ></i>
//                                   )}
//                                 </div>
//                               </div>
//                             </div>

//                             <div
//                               className={`step-card ${
//                                 isAnimated ? "card-fade-in" : ""
//                               }`}
//                             >
//                               <div className="step-avatar-wrapper">
//                                 <div
//                                   className={`step-avatar-small ${
//                                     isAnimated ? "avatar-fill" : ""
//                                   }`}
//                                 >
//                                   {isAnimated && (
//                                     <div
//                                       className="avatar-fill-bg"
//                                       style={{
//                                         backgroundColor: config.fillColor,
//                                       }}
//                                     ></div>
//                                   )}
//                                   <i
//                                     className={`${config.icon} avatar-icon-small`}
//                                   ></i>
//                                 </div>
//                               </div>

//                               <div className="step-info">
//                                 <h6 className="step-name">
//                                   {item?.approveresInfo?.[0]?.firstName ||
//                                     "SYSTEM"}
//                                   {item?.approveresInfo?.[0]?.userId && (
//                                     <span className="step-id">
//                                       [{item.approveresInfo[0].userId}]
//                                     </span>
//                                   )}
//                                 </h6>
//                                 <p className="step-role">
//                                   <i
//                                     className={`${config.icon} me-1`}
//                                     style={{
//                                       fontSize: "0.7rem",
//                                     }}
//                                   ></i>
//                                   {item.currentAction === "Created"
//                                     ? "RFQ INITIATOR"
//                                     : item.currentAction === "Pending"
//                                       ? "PENDING APPROVAL"
//                                       : item.currentAction === "Approve"
//                                         ? "RFQ COMM APPROVER"
//                                         : item.currentAction === "Submit"
//                                           ? "SUBMITTED"
//                                           : item.currentAction === "Reject"
//                                             ? "REJECTED"
//                                             : "RFQ COMMERCIAL COMPLETION"}
//                                 </p>
//                               </div>

//                               <div
//                                 className={`step-status ${
//                                   isCompleted ? "completed-status" : ""
//                                 } ${isPending ? "pending-pulse" : ""}`}
//                                 style={{
//                                   backgroundColor: config.labelBg,
//                                   color: config.color,
//                                   borderColor: config.color,
//                                 }}
//                               >
//                                 <i
//                                   className={`${config.icon} me-1`}
//                                   style={{
//                                     fontSize: "0.8rem",
//                                   }}
//                                 ></i>
//                                 {config.status}
//                               </div>

//                               <div className="step-time">
//                                 <span className="time-ago">
//                                   <i
//                                     className="bi bi-clock me-1"
//                                     style={{
//                                       fontSize: "0.75rem",
//                                     }}
//                                   ></i>
//                                   {formatTimeDifference(item.updatedAt)}
//                                 </span>
//                                 <span className="time-stamp">
//                                   <i
//                                     className="bi bi-calendar3 me-1"
//                                     style={{
//                                       fontSize: "0.7rem",
//                                     }}
//                                   ></i>
//                                   {new Date(item.updatedAt).toLocaleString(
//                                     "en-US",
//                                     {
//                                       month: "2-digit",
//                                       day: "2-digit",
//                                       year: "2-digit",
//                                       hour: "2-digit",
//                                       minute: "2-digit",
//                                       hour12: true,
//                                     },
//                                   )}
//                                 </span>
//                               </div>
//                             </div>
//                           </div>
//                         );
//                       })}
//                   </div>
//                 ) : (
//                   <div className="timeline-horizontal-compact">
//                     <div className="connecting-line">
//                       <div
//                         className="connecting-line-fill"
//                         style={{
//                           width: `${getProgressPercent()}%`,
//                         }}
//                       ></div>
//                     </div>

//                     {loadData?.length > 0 &&
//                       loadData.map((item, index) => {
//                         const config = getStatusConfig(item.currentAction);
//                         const isFirst = index === 0;
//                         const isLast = index === loadData.length - 1;
//                         const isCompleted = item.currentAction === "Completed";
//                         const isAnimated = animateSteps.includes(index);
//                         const isPending = isPendingOrRejected(
//                           item.currentAction,
//                         );

//                         return (
//                           <div key={index} className="timeline-step-compact">
//                             <div
//                               className={`step-circle ${
//                                 isFirst
//                                   ? "start-circle"
//                                   : isLast
//                                     ? "end-circle"
//                                     : "middle-circle"
//                               } ${isAnimated ? "animate-fill" : ""}`}
//                             >
//                               {!isFirst && !isLast && isAnimated && (
//                                 <div
//                                   className="circle-fill"
//                                   style={{
//                                     backgroundColor: config.fillColor,
//                                   }}
//                                 ></div>
//                               )}

//                               <div className="circle-content">
//                                 {isFirst ? (
//                                   <span className="circle-text">START</span>
//                                 ) : isLast && isCompleted ? (
//                                   <i className="bi bi-check-all circle-icon-small"></i>
//                                 ) : (
//                                   <i
//                                     className={`${config.icon} circle-icon-small`}
//                                   ></i>
//                                 )}
//                               </div>
//                             </div>

//                             <div className="compact-label">
//                               <span
//                                 className={`compact-status-badge ${
//                                   isPending ? "pending-pulse-compact" : ""
//                                 }`}
//                                 style={{
//                                   backgroundColor: config.labelBg,
//                                   color: config.color,
//                                   borderColor: config.color,
//                                 }}
//                               >
//                                 <i
//                                   className={`${config.icon} me-1`}
//                                   style={{ fontSize: "0.7rem" }}
//                                 ></i>
//                                 {config.status}
//                               </span>
//                               <span className="compact-name">
//                                 {item?.approveresInfo?.[0]?.firstName ||
//                                   "SYSTEM"}
//                               </span>
//                             </div>
//                           </div>
//                         );
//                       })}
//                   </div>
//                 )}
//               </div>
//             </div>
//           </Col>
//         </Row>
//       )}
//     </div>
//   );
// });

// export default ShowHorizontalStatus;


import React, { useEffect, useState, forwardRef } from "react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { formatTimeDifference } from "../../../../common/Validations";
import "./ShowHorizontalStatus.css";

const ShowHorizontalStatus = forwardRef((props, ref) => {
  const [loadData, setLoadData] = useState(props?.rowdatamodal);
  const [animateSteps, setAnimateSteps] = useState([]);
  const isDetailedView = props?.isDetailedView || false;

  useEffect(() => {
    setLoadData(props?.rowdatamodal);

    if (props?.rowdatamodal?.length > 0) {
      props.rowdatamodal.forEach((_, index) => {
        setTimeout(() => {
          setAnimateSteps((prev) => [...prev, index]);
        }, index * 300);
      });
    }
  }, [props?.rowdatamodal]);

  // FIXED: now derives the visual state from BOTH workflowStatus and
  // currentAction, instead of currentAction alone. Previously every
  // User_Task step (whether Open, Pending, or Closed) had
  // currentAction === "Approve", so they all matched the "Approve" key
  // below and were rendered as green "Approved" regardless of whether
  // anyone had actually approved them.
  const getStatusConfig = (item) => {
    const { workflowStatus, currentAction } = item || {};

    let key;
    if (workflowStatus === "Closed" && currentAction === "Created") {
      // Initial system "Create" step, already done
      key = "Created";
    } else if (currentAction === "Reject") {
      key = "Reject";
    } else if (workflowStatus === "Open" && currentAction === "Approve") {
      // This is the step currently awaiting action from this approver
      key = "InProgress";
    } else if (workflowStatus === "Pending" && currentAction === "Approve") {
      // Future approval step, not reached yet
      key = "NotStarted";
    } else if (workflowStatus === "Closed" && currentAction === "Approved") {
      // Actually approved by the user
      key = "Approved";
    } else if (workflowStatus === "Closed" && currentAction === "Completed") {
      key = "Completed";
    } else if (workflowStatus === "Pending" && currentAction === "Completed") {
      // Completion step not reached yet
      key = "NotStarted";
    } else if (currentAction === "Submit") {
      key = "Submit";
    } else {
      key = "NotStarted";
    }

    const configs = {
      Created: {
        badge: "CB",
        color: "#dc3545",
        status: "Created",
        labelBg: "#fff1f0",
        icon: "bi-pencil-square",
        fillColor: "#28a745",
      },
      // FIXED: replaces the old "Pending" key. Used for steps that are
      // still in the future (workflowStatus === "Pending") — these are
      // NOT approved yet and should look neutral/inactive, not green.
      NotStarted: {
        badge: "PD",
        color: "#6c757d",
        status: "Pending",
        labelBg: "#f5f5f5",
        icon: "bi-hourglass-split",
        fillColor: "#6c757d",
      },
      // NEW: the step that is currently open and awaiting action from
      // its approver. This used to incorrectly reuse the "Approve" key
      // below and render as green "Approved".
      InProgress: {
        badge: "PA",
        color: "#fd7e14",
        status: "Pending Approval",
        labelBg: "#fff4e5",
        icon: "bi-hourglass-split",
        fillColor: "#fd7e14",
      },
      // Kept from original code (old "Approve" + "Approved" keys merged
      // into one, since both rendered identically). Only reached now
      // when workflowStatus === "Closed" && currentAction === "Approved",
      // i.e. someone has actually approved this step.
      Approved: {
        badge: "AP",
        color: "#28a745",
        status: "Approved",
        labelBg: "#e8f5e9",
        icon: "bi-check-circle-fill",
        fillColor: "#28a745",
      },
      Submit: {
        badge: "SB",
        color: "#17a2b8",
        status: "Submit",
        labelBg: "#e0f7fa",
        icon: "bi-send-fill",
        fillColor: "#17a2b8",
      },
      Reject: {
        badge: "RJ",
        color: "#dc3545",
        status: "Rejected",
        labelBg: "#ffebee",
        icon: "bi-x-circle-fill",
        fillColor: "#dc3545",
      },
      Completed: {
        badge: "SY",
        color: "#0d6efd",
        status: "Completed",
        labelBg: "#e3f2fd",
        icon: "bi-check-all",
        fillColor: "#0d6efd",
      },
    };

    return (
      configs[key] || {
        badge: "NA",
        color: "#6c757d",
        status: "-",
        labelBg: "#f5f5f5",
        icon: "bi-question-circle",
        fillColor: "#6c757d",
      }
    );
  };

  // FIXED: now takes the full item and checks workflowStatus, since
  // currentAction === "Approve" no longer implies "not yet done" by
  // itself (an Open step and a Pending step both had currentAction
  // "Approve" in the old data model).
  const isPendingOrRejected = (item) => {
    return (
      item.currentAction === "Reject" ||
      (item.workflowStatus === "Pending" && item.currentAction !== "Created")
    );
  };

  // FIXED: previously looked for currentAction === "Pending", which
  // never actually occurs in the data (workflowStatus, not
  // currentAction, is what holds the value "Pending"). That meant
  // stopIndex was always -1 and the progress bar always filled to
  // 100% immediately on document creation. Now it stops at the first
  // step whose workflowStatus is not yet "Closed".
  const getProgressPercent = () => {
    if (!loadData || loadData.length === 0) return 0;

    const totalSteps = loadData.length;

    const stopIndex = loadData.findIndex(
      (item) => item.workflowStatus !== "Closed",
    );

    if (stopIndex === -1) {
      return 100;
    } else if (stopIndex === 0) {
      return 0;
    } else {
      const completedSteps = stopIndex - 1;
      const totalSegments = totalSteps - 1;
      const basePercent = (completedSteps / totalSegments) * 100;
      const segmentWidth = 100 / totalSegments;
      const extensionPercent = segmentWidth * 0.25;
      return basePercent + extensionPercent;
    }
  };

  return (
    <div className="workflow-status-wrapper" ref={ref}>
      {loadData && (
        <Row className="workflow-status-row">
          <Col xs={12} className="workflow-status-col">
            <div className="card border-0 shadow-sm workflow-status-card">
              <div className="card-body workflow-status-body">
                {isDetailedView ? (
                  <div className="timeline-horizontal">
                    <div className="connecting-line">
                      <div
                        className="connecting-line-fill"
                        style={{
                          width: `${getProgressPercent()}%`,
                        }}
                      ></div>
                    </div>

                    {loadData?.length > 0 &&
                      loadData.map((item, index) => {
                        const config = getStatusConfig(item);
                        const isFirst = index === 0;
                        const isLast = index === loadData.length - 1;
                        const isCompleted =
                          item.currentAction === "Completed" &&
                          item.workflowStatus === "Closed";
                        const isAnimated = animateSteps.includes(index);
                        const isPending = isPendingOrRejected(item);

                        return (
                          <div key={index} className="timeline-step">
                            <div className="step-circle-wrapper">
                              <div
                                className={`step-circle ${
                                  isFirst
                                    ? "start-circle"
                                    : isLast
                                      ? "end-circle"
                                      : "middle-circle"
                                } ${isAnimated ? "animate-fill" : ""}`}
                              >
                                {!isFirst && !isLast && isAnimated && (
                                  <div
                                    className="circle-fill"
                                    style={{
                                      backgroundColor: config.fillColor,
                                    }}
                                  ></div>
                                )}

                                <div className="circle-content">
                                  {isFirst ? (
                                    <span className="circle-text">START</span>
                                  ) : isLast && isCompleted ? (
                                    <i className="bi bi-check-all circle-icon-small"></i>
                                  ) : (
                                    <i
                                      className={`${config.icon} circle-icon-small`}
                                    ></i>
                                  )}
                                </div>
                              </div>
                            </div>

                            <div
                              className={`step-card ${
                                isAnimated ? "card-fade-in" : ""
                              }`}
                            >
                              <div className="step-avatar-wrapper">
                                <div
                                  className={`step-avatar-small ${
                                    isAnimated ? "avatar-fill" : ""
                                  }`}
                                >
                                  {isAnimated && (
                                    <div
                                      className="avatar-fill-bg"
                                      style={{
                                        backgroundColor: config.fillColor,
                                      }}
                                    ></div>
                                  )}
                                  <i
                                    className={`${config.icon} avatar-icon-small`}
                                  ></i>
                                </div>
                              </div>

                              <div className="step-info">
                                <h6 className="step-name">
                                  {item?.approveresInfo?.[0]?.firstName ||
                                    "SYSTEM"}
                                  {item?.approveresInfo?.[0]?.userId && (
                                    <span className="step-id">
                                      [{item.approveresInfo[0].userId}]
                                    </span>
                                  )}
                                </h6>
                                <p className="step-role">
                                  <i
                                    className={`${config.icon} me-1`}
                                    style={{
                                      fontSize: "0.7rem",
                                    }}
                                  ></i>
                                  {item.currentAction === "Created"
                                    ? "RFQ INITIATOR"
                                    : item.currentAction === "Pending"
                                      ? "PENDING APPROVAL"
                                      : item.currentAction === "Approve"
                                        ? "RFQ COMM APPROVER"
                                        : item.currentAction === "Submit"
                                          ? "SUBMITTED"
                                          : item.currentAction === "Reject"
                                            ? "REJECTED"
                                            : "RFQ COMMERCIAL COMPLETION"}
                                </p>
                              </div>

                              <div
                                className={`step-status ${
                                  isCompleted ? "completed-status" : ""
                                } ${isPending ? "pending-pulse" : ""}`}
                                style={{
                                  backgroundColor: config.labelBg,
                                  color: config.color,
                                  borderColor: config.color,
                                }}
                              >
                                <i
                                  className={`${config.icon} me-1`}
                                  style={{
                                    fontSize: "0.8rem",
                                  }}
                                ></i>
                                {config.status}
                              </div>

                              <div className="step-time">
                                <span className="time-ago">
                                  <i
                                    className="bi bi-clock me-1"
                                    style={{
                                      fontSize: "0.75rem",
                                    }}
                                  ></i>
                                  {formatTimeDifference(item.updatedAt)}
                                </span>
                                <span className="time-stamp">
                                  <i
                                    className="bi bi-calendar3 me-1"
                                    style={{
                                      fontSize: "0.7rem",
                                    }}
                                  ></i>
                                  {new Date(item.updatedAt).toLocaleString(
                                    "en-US",
                                    {
                                      month: "2-digit",
                                      day: "2-digit",
                                      year: "2-digit",
                                      hour: "2-digit",
                                      minute: "2-digit",
                                      hour12: true,
                                    },
                                  )}
                                </span>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                  </div>
                ) : (
                  <div className="timeline-horizontal-compact">
                    <div className="connecting-line">
                      <div
                        className="connecting-line-fill"
                        style={{
                          width: `${getProgressPercent()}%`,
                        }}
                      ></div>
                    </div>

                    {loadData?.length > 0 &&
                      loadData.map((item, index) => {
                        const config = getStatusConfig(item);
                        const isFirst = index === 0;
                        const isLast = index === loadData.length - 1;
                        const isCompleted =
                          item.currentAction === "Completed" &&
                          item.workflowStatus === "Closed";
                        const isAnimated = animateSteps.includes(index);
                        const isPending = isPendingOrRejected(item);

                        return (
                          <div key={index} className="timeline-step-compact">
                            <div
                              className={`step-circle ${
                                isFirst
                                  ? "start-circle"
                                  : isLast
                                    ? "end-circle"
                                    : "middle-circle"
                              } ${isAnimated ? "animate-fill" : ""}`}
                            >
                              {!isFirst && !isLast && isAnimated && (
                                <div
                                  className="circle-fill"
                                  style={{
                                    backgroundColor: config.fillColor,
                                  }}
                                ></div>
                              )}

                              <div className="circle-content">
                                {isFirst ? (
                                  <span className="circle-text">START</span>
                                ) : isLast && isCompleted ? (
                                  <i className="bi bi-check-all circle-icon-small"></i>
                                ) : (
                                  <i
                                    className={`${config.icon} circle-icon-small`}
                                  ></i>
                                )}
                              </div>
                            </div>

                            <div className="compact-label">
                              <span
                                className={`compact-status-badge ${
                                  isPending ? "pending-pulse-compact" : ""
                                }`}
                                style={{
                                  backgroundColor: config.labelBg,
                                  color: config.color,
                                  borderColor: config.color,
                                }}
                              >
                                <i
                                  className={`${config.icon} me-1`}
                                  style={{ fontSize: "0.7rem" }}
                                ></i>
                                {config.status}
                              </span>
                              <span className="compact-name">
                                {item?.approveresInfo?.[0]?.firstName ||
                                  "SYSTEM"}
                              </span>
                            </div>
                          </div>
                        );
                      })}
                  </div>
                )}
              </div>
            </div>
          </Col>
        </Row>
      )}
    </div>
  );
});

export default ShowHorizontalStatus;